import Inbox from "@material-ui/icons/Inbox";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import React, { ReactElement } from "react";
import { startCase } from "lodash";
import { Button, useRedirect } from "react-admin";
import IconPlus from "@material-ui/icons/Add";

interface ICustomEmptyComponent {
  resource: string;
  hasCreate: boolean;
  optionalQuery?: string;
  title?: string;
  caption?: string;
  url?: string;
  buttonLabel?: string;
  buttonIcon?: ReactElement;
}

const useStyles = makeStyles({
  wrapper: {
    margin: "16px auto",
  },
  message: {
    textAlign: "center",
    opacity: 0.5,
    margin: "0 1em",
    color: "inherit",
  },
  icon: {
    width: "9em",
    height: "9em",
  },
  toolbar: {
    textAlign: "center",
    marginTop: "2em",
  },
});

const CustomEmptyComponent = ({
  resource,
  hasCreate,
  optionalQuery,
  title,
  caption,
  url,
  buttonLabel,
  buttonIcon
}: ICustomEmptyComponent) => {
  const classes = useStyles();
  const redirect = useRedirect();

  const redirectUrl = url
    ? url
    : `/${resource}/create${optionalQuery ? optionalQuery : ""}`;

  return (
    <Box className={classes.wrapper}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <div className={classes.message}>
            <Inbox className={classes.icon} />
            <Typography variant="h4" paragraph>
              {title ? title : `No ${startCase(resource)}`}
            </Typography>
            {caption && <Typography variant="body1">{caption}</Typography>}
            {hasCreate && !caption && (
              <Typography variant="body1">
                Click the button below to create a new {startCase(resource)}.
              </Typography>
            )}
          </div>
          {hasCreate && (
            <div className={classes.toolbar}>
              <Button
                onClick={() => redirect(redirectUrl)}
                label={buttonLabel ? buttonLabel : "Create"}
              >
                {buttonIcon ? buttonIcon : <IconPlus />}
              </Button>
            </div>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomEmptyComponent;
